<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.StartImage != null">
                        <img class="login-logo-img" :src="info.StartImage" />
                    </div>
                    <div class="login">
                        <template v-if="result != null">
                            <div class="form-header">
                                Авторизация
                            </div>
                            <div class="auth-content-block">
                                <div class="form-field">
                                    <b>Логин:</b> {{result.login}}
                                </div>
                                <div class="form-field">
                                    <b>Пароль:</b> {{result.password}}
                                </div>
                            </div>
                            <div class="form-actions margin-top-20">
                                <div class="form-btns">
                                    <button type="submit" class="btn btn-primary" @click="$router.push('/login')">
                                        Авторизация
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <vue-headful title="Забыли пароль?" />
    </div>
</template>

<script>
  import UI from '../helpers/ui-helpers'
  import BackendApi from '../backendApi'

  let backendApi = new BackendApi();

  export default {
      name: "reset-password",

      props: ['info'],

      data(){
          return{
              result: null
          }
      },

      mounted() {
          let vm = this;

          let hash = vm.$route.params.hash;
          if(!hash){
              vm.$router.push('/login');
          }

          backendApi.userResetPassword(hash).then(function (response) {
              //console.info('reset -> backendApi.checkResetHash, response:', response);
              if (response.hasError) {
                  if(response.status === 1404){
                      // неверный hash
                      console.info('неверный hash');
                      vm.$router.push('/login');
                  }
                  else{
                      UI.toastr.error('Ошибка при загрузке страницы');
                  }
              }
              else {
                  if (response.data != null) {
                      vm.result = response.data;
                  }
              }
          });
      }

  }
</script>

<style scoped="">

</style>


// WEBPACK FOOTER //
// Content/src/views/ResetPassword.vue